import { Icons } from '@/assets/icons/icons';
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRoot,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu/dropdown-menu';
import { XStack } from '@/components/ui/layout/layout';

interface McpInfoFilterDropdownOption {
  value: string;
  label: string;
  count?: number;
}

interface McpInfoFilterDropdownProps {
  title: string;
  selectedValue: string | null;
  allLabel: string;
  options: McpInfoFilterDropdownOption[];
  onSelect: (value: string | null) => void;
}

export function McpInfoFilterDropdown({
  title,
  selectedValue,
  allLabel,
  options,
  onSelect,
}: McpInfoFilterDropdownProps) {
  const selectedLabel =
    options.find((option) => option.value === selectedValue)?.label ?? allLabel;

  return (
    <DropdownMenuRoot>
      <DropdownMenuTrigger size="sm">
        <span className="truncate max-w-[140px]">{selectedLabel}</span>
        <Icons.chevronDown className="h-3 w-3 shrink-0" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>{title}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => onSelect(null)}
          className={!selectedValue ? 'bg-secondary-active' : ''}
        >
          {allLabel}
        </DropdownMenuItem>
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => onSelect(option.value)}
            className={
              selectedValue === option.value ? 'bg-secondary-active' : ''
            }
          >
            <XStack className="justify-between items-center w-full gap-2">
              <span className="truncate">{option.label}</span>
              {option.count !== undefined && (
                <span className="text-xs text-foreground-muted shrink-0">
                  {option.count}
                </span>
              )}
            </XStack>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenuRoot>
  );
}
